/**
 * 食材 配置表
 * @constructor
 */

export default function FoodMaterialConfig() {
    const dataJson : FoodMaterialEntity[] = [
        {
            uniqueId:1,
            name:"冰块",
            type : 1,
            imgPath : "ice",
            videoFlag:true,
            goodsId : 21200 ,
            combinationUpPrice : 20,
            combinationDownPrice : -30,
        },
        {
            uniqueId:2,
            name:"龙虾",
            type : 1,
            imgPath : "lobster",
            videoFlag:true,
            goodsId : 21202 ,
            combinationUpPrice : 600,
            combinationDownPrice : 100,
        },
        {
            uniqueId : 3,
            name : "柠檬",
            type : 1,
            imgPath : "lemon",
            videoFlag:true,
            goodsId : 21201 ,
            combinationUpPrice : 100,
            combinationDownPrice : -50,
        },
        {
            uniqueId : 4,
            name : "奥利给",
            type : 1,
            imgPath : "shit",
            videoFlag:true,
            goodsId : 21110 ,
            combinationUpPrice : -165,
            combinationDownPrice : -700,
        },
        {
            uniqueId : 5,
            name : "黄金",
            type : 1,
            imgPath : "gold",
            videoFlag:true,
            goodsId : 22001 ,
            combinationUpPrice : 600,
            combinationDownPrice : 400,
        },
        {
            uniqueId : 6,
            name : "土鸡蛋",
            type : 1,
            imgPath : "egg",
            videoFlag:true,
            goodsId : 21001 ,
            combinationUpPrice : 50,
            combinationDownPrice : 20,
        },
        {
            uniqueId : 7,
            name : "大肠",
            type : 1,
            videoFlag:true,
            imgPath : "intestine",
            goodsId : 22002 ,
            combinationUpPrice : 200,
            combinationDownPrice : 50,
        },
        {
            uniqueId : 8,
            name : "空气瓶",
            type : 1,
            videoFlag:true,
            imgPath : "air",
            goodsId : 22003 ,
            combinationUpPrice : 2000,
            combinationDownPrice : 2000,
        },
        {
            uniqueId : 9,
            name : "金盘子",
            type : 2,
            videoFlag:true,
            imgPath : "goodPlate",
            combinationUpPrice : 10000,
            combinationDownPrice : 0,
        },
    ];
    return dataJson;
}

/**
 * 食材 Entity
 */
export class FoodMaterialEntity {
    uniqueId : number;
    name : string;
    type : number;//1 普通 ， 2 特制
    imgPath : string;
    videoFlag?:boolean;//是否可以通过看视频获取 如果可以通过视频获取则数量为0时一样会显示在界面上
    goodsId ?: number;
    combinationUpPrice : number;
    combinationDownPrice : number;
}

export interface FoodMaterialGiveInterface{
    id:number,
    count:number
}

/**
 * 通过id获取
 * @param id
 */
export function getFoodMaterialEntityById ( id : number ){
    return FoodMaterialConfig().find(( item,index, dataList)=>{
        return item.uniqueId == id;
    });
}

export function getFoodMaterialGiveAry():FoodMaterialGiveInterface[]{
    return [
        {id:21001,count:10},
        {id:21110,count:10},
        {id:21200,count:10},
        {id:21201,count:10},
        {id:21202,count:10},
        {id:22001,count:5},
        {id:22002,count:9},
        {id:22003,count:5},
    ]
}

